module.exports = __webpack_public_path__ + "img/qrcode.669acceb.jpeg";